
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-rule":"evenodd","fill":"#4a3428","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"m19.0588 5h-14.11762c-.78005 0-1.52815.30987-2.07973.86145s-.86145 1.29968-.86145 2.07973v8.23532c0 .78.30987 1.5281.86145 2.0797s1.29968.8614 2.07973.8614h14.11762c.7801 0 1.5282-.3098 2.0797-.8614.5516-.5516.8615-1.2997.8615-2.0797v-8.23532c0-.78005-.3099-1.52815-.8615-2.07973-.5515-.55158-1.2996-.86145-2.0797-.86145zm-15.88233 2.94118c0-.46803.18592-.91689.51687-1.24784s.77981-.51687 1.24784-.51687h14.11762c.4681 0 .9169.18592 1.2479.51687.3309.33095.5168.77981.5168 1.24784v8.23532c0 .468-.1859.9169-.5168 1.2478-.331.331-.7798.5169-1.2479.5169h-14.11762c-.46803 0-.91689-.1859-1.24784-.5169-.33095-.3309-.51687-.7798-.51687-1.2478z"}}),_c('path',{attrs:{"d":"m3.17637 7.94116h17.64703c.156 0 .3057.06198.416.17229.1103.11032.1723.25994.1723.41595v1.17647c0 .15601-.062.30563-.1723.41593s-.26.1723-.416.1723h-17.64703c-.15601 0-.30563-.062-.41594-.1723-.11032-.1103-.1723-.25992-.1723-.41593v-1.17647c0-.15601.06198-.30563.1723-.41595.11031-.11031.25993-.17229.41594-.17229zm4.11765 3.52944h-1.17647c-.31202 0-.61126.1239-.83189.3446-.22063.2206-.34458.5198-.34458.8318v1.1765c0 .312.12395.6113.34458.8319s.51987.3446.83189.3446h1.17647c.31202 0 .61126-.124.83189-.3446s.34458-.5199.34458-.8319v-1.1765c0-.312-.12395-.6112-.34458-.8318-.22063-.2207-.51987-.3446-.83189-.3446zm-1.17647 2.3529v-1.1765h1.17647v1.1765z"}})])])
          )
        }
      }
    